import { FC, useMemo } from "react";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import AttributeSummaryCard from "./AttributeSummaryCard";
import { ChildrenProductAttribute, ProductAttribute } from "./types";
import { ProductCountCard } from "./ProductCountCard";
import { VendorCountCard } from "./VendorCountCard";
import { CompanyCountCard } from "./CompanyCountCard";
import { InstallCountCard } from "./InstallCountCard";
import { AttributeProductTable } from "./AttributeProductTable";
import { OutlinedPaper } from "../../../components/OutlinedPaper";

interface AttributeContentProps {
  matchedProductAttribute: ProductAttribute | ChildrenProductAttribute;
  isLoading: boolean;
}

export const AttributeContent: FC<AttributeContentProps> = (props) => {
  const attribute = useMemo(() => {
    return {
      id: props.matchedProductAttribute.id || 0,
      name: props.matchedProductAttribute?.name || "unknown",
      description: props.matchedProductAttribute?.description || undefined,
    };
  }, [props.matchedProductAttribute]);

  return (
    <Stack gap={3} p={2}>
      <AttributeSummaryCard
        attributeName={attribute.name}
        isLoading={props.isLoading}
        attributeDescription={attribute.description}
      />

      <Box display="flex" gap={1}>
        <ProductCountCard attributeId={attribute.id} />
        <VendorCountCard attributeId={attribute.id} />
      </Box>

      <Box display="flex" gap={1}>
        <CompanyCountCard attributeId={attribute.id} />
        <InstallCountCard attributeId={attribute.id} />
      </Box>

      <OutlinedPaper sx={{ p: 3 }}>
        <AttributeProductTable
          attributeId={attribute.id}
          attributeName={attribute.name}
        />
      </OutlinedPaper>
    </Stack>
  );
};
